"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var collectedFilters_1 = require("../../../../common/service/collectedFilters");
var useCheckoutContext_1 = require("../../../common/hooks/useCheckoutContext");
var useSelectDealer_1 = require("./mutations/useSelectDealer");
var useDealers_1 = require("./useDealers");
var useDealerSelectorDataPrep = function () {
    var _a, _b, _c;
    var _d = react_1.useState({
        __typename: 'MapLocation',
        latitude: 0,
        longitude: 0,
    }), defaultDealer = _d[0], setDefaultDealer = _d[1];
    var _e = useCheckoutContext_1.default(), deal = _e.deal, customerInformation = _e.customerInformation;
    var _f = useDealers_1.useDealers(), data = _f.data, loading = _f.loading, error = _f.error;
    var filters = collectedFilters_1.default().filters;
    var initialDealerId = (_b = (_a = deal) === null || _a === void 0 ? void 0 : _a.dealer) === null || _b === void 0 ? void 0 : _b.externalId;
    var _g = react_1.useState(initialDealerId), selectedDealerId = _g[0], setSelectedDealerId = _g[1];
    var _h = react_1.useState(null), customerPreferredDealerId = _h[0], setCustomerPreferredDealerId = _h[1];
    var _j = react_1.useState([]), dealers = _j[0], setDealers = _j[1];
    var currentDealer = dealers.find(function (_a) {
        var externalId = _a.externalId;
        return externalId === selectedDealerId;
    });
    var _k = useSelectDealer_1.useSelectDealer(filters.token, "" + (((_c = currentDealer) === null || _c === void 0 ? void 0 : _c.id) || '')), selectDealerMutation = _k.selectDealer, loadingSelectDealer = _k.loading, selectDealerError = _k.error;
    var disabled = loadingSelectDealer || !currentDealer;
    react_1.useEffect(function () {
        var _a, _b;
        if (customerInformation) {
            setCustomerPreferredDealerId((_b = (_a = customerInformation) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.preferredDealerKey);
        }
    }, [customerInformation]);
    react_1.useEffect(function () {
        setSelectedDealerId(initialDealerId);
    }, [initialDealerId]);
    react_1.useEffect(function () {
        if (!loading && !error) {
            setDealers(data.dealers.nodes);
            setDefaultDealer(data.dealers.defaultMapLocation);
        }
    }, [loading, data]);
    return {
        selectDealerMutation: selectDealerMutation,
        disabled: disabled,
        defaultDealer: defaultDealer,
        dealers: dealers,
        selectedDealerId: selectedDealerId,
        setSelectedDealerId: setSelectedDealerId,
        loading: loading,
        error: error || selectDealerError,
        currentDealer: currentDealer,
        customerPreferredDealerId: customerPreferredDealerId,
    };
};
exports.default = useDealerSelectorDataPrep;
